import { motion } from "framer-motion";
import { Compass, TrendingUp, Cog, BarChart3, ClipboardList, Truck, FileCheck, Car, Building2 } from "lucide-react";
import { SERVICES } from "../data/services";

const ICONS = {
  advisory: Compass,
  commercial: TrendingUp,
  operations: Cog,
  market_analysis: BarChart3,
  inventory: ClipboardList,
  maintenance_logistics: Truck,
  permits: FileCheck,
  executive_transport: Car,
  property_admin: Building2,
};

export const Services = ({ t, lang }) => (
  <section id="services" data-testid="services-section" className="relative scroll-mt-24 px-5 py-24 sm:px-8 sm:py-32">
    <div className="mx-auto max-w-7xl">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14 max-w-2xl"
      >
        <span className="text-xs font-semibold uppercase tracking-[0.28em] text-amber-400">{t.services.eyebrow}</span>
        <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">{t.services.title}</h2>
        <p className="mt-4 text-base text-slate-400 sm:text-lg">{t.services.sub}</p>
      </motion.div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-12 md:auto-rows-[minmax(170px,auto)]">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.id];
          return (
            <motion.div
              key={s.id}
              data-testid={`service-card-${s.id}`}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.65, delay: (i % 3) * 0.08 }}
              className={`group relative col-span-1 overflow-hidden rounded-2xl border border-white/10 ${s.span} ${
                s.featured ? "gold-trace" : ""
              } bg-[#121722] p-7 transition-colors duration-500 hover:border-amber-400/30`}
            >
              {s.image && (
                <>
                  <img
                    src={s.image}
                    alt=""
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover opacity-25 transition-transform duration-[1.2s] ease-out group-hover:scale-105 group-hover:opacity-35"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0D14] via-[#0A0D14]/70 to-[#0A0D14]/30" />
                </>
              )}
              <div className="relative flex h-full flex-col justify-between gap-6">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-amber-400/25 bg-amber-400/10">
                  <Icon className="h-5 w-5 text-amber-400" />
                </div>
                <div>
                  <h3 className="font-display text-xl font-semibold text-white sm:text-2xl">{s.title[lang]}</h3>
                  <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-400">{s.desc[lang]}</p>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
